import { Button, Center } from '@chakra-ui/react'
import React from 'react'

import { IconChevronRight } from '~shared-components/icons/brand/IconChevronRight'

interface Props {
  isOpen?: boolean
  onClick?: () => void
}
export const SidebarToggleButton = ({ isOpen, onClick }: Props) => (
  <Button
    _focus={{
      border: '1px solid',
      borderColor: 'deepPurple',
    }}
    alignContent="center"
    aria-hidden="true"
    color="neutral.90"
    data-analyticsid="close-open-sidebar"
    height={6}
    minWidth="unset"
    onClick={onClick}
    size="md"
    width={6}
  >
    <Center>
      <IconChevronRight
        boxSize="24px"
        transform={isOpen ? 'rotate(180deg)' : 'rotate(0deg)'}
        transition="transform 500ms ease-in-out"
      />
    </Center>
  </Button>
)
